import React from "react";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";

import { Link } from "gatsby";

import { Menu } from "@headlessui/react";
import { oauthSignInHandler } from "services/auth";
import Tracker from "services/gaTracker";

import Dropdown from "components/Dropdown/DropdownWithLinks";

import poloThemesLogo from "images/placeholders/polo-themes-logo.png";
import profileDefaultImage from "images/png/profile.png";
import ChevronDown from "images/svg/chevron-down.svg";
import ChevronUp from "images/svg/chevron-up.svg";

import { ROUTES } from "constants/routes";

const Header: React.FC = () => {
  const [isLoggedIN, setIsLoggedIn] = useState(false);
  const [viewMenuMobile, setViewMenuMobile] = useState(false);
  const [user, setUser] = useState<any>("");
  const [dropdownIconToggle, setDropdownIconToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // @ This is used in dropdown on header that is commented out
  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const servicesDropdownArray = [
    { key: 1, name: "Support", url: "/support" },
    { key: 2, name: "FAQ", url: "/faq" },
  ];

  const profileDropdownArray = [
    // { key: 1, name: "Profile", url: "/profile" },
    { key: 2, name: "Purchase History", url: "/purchase-history" },
    // { key: 3, name: "Setting", url: "/setting" },
  ];

  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const handleDropdownIconToggle = () => {
    setDropdownIconToggle(!dropdownIconToggle);
  };

  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const dropDownIcon = dropdownIconToggle ? ChevronDown : ChevronUp;

  // * Image from gumroad or default placeholder Image.
  const userImage = user.profile_url ? user.profile_url : profileDefaultImage;

  const bgMobileMenuClass = viewMenuMobile ? "bg-primary-1000" : "";
  const showMenuClass = viewMenuMobile ? "overflow-auto" : "hidden";
  const logoColorClass = viewMenuMobile ? "text-white" : "text-black";
  // const logoCrossViewClass = viewMenuMobile ? "visible" : "hidden";
  const logoSecondColorClass = viewMenuMobile
    ? "text-white"
    : "text-primary-500";
  const toggleLogoClass = viewMenuMobile ? "text-white" : "";
  const navHeightToggleClass = viewMenuMobile ? "inset-0" : "h-auto";
  const navToggleClass = viewMenuMobile
    ? "fixed top-0 left-0 right-0 bottom-0 z-50"
    : "";

  useEffect(() => {
    const userinfo = window.localStorage.getItem("user");

    if (userinfo) {
      setIsLoggedIn(true);
      setUser(JSON.parse(userinfo));
    } else {
      setIsLoggedIn(false);
    }
    setIsLoading(false);
  }, []);

  const signOutHandler = () => {
    window.localStorage.removeItem("user");
    setIsLoggedIn(false);
  };

  const toggleViewMenu = () => {
    setViewMenuMobile(!viewMenuMobile);
  };

  const signInHandler = () => {
    Tracker.trackLogin("gumroad");
    oauthSignInHandler();
  };

  const closeNavBar = () => {
    setViewMenuMobile(false);
  };

  const [theme, setTheme] = useState("light");

  // useEffect(() => {
  //   if (theme === "theme-orange") {
  //     document.documentElement.classList.add("theme-orange");
  //   } else {
  //     document.documentElement.classList.remove("theme-orange");
  //   }
  // }, [theme]);

  // const handleThemeSwitch = () => {
  //   setTheme(theme === "theme-orange" ? "light" : "theme-orange");
  // };

  useEffect(() => {
    if (theme === "theme-orange") {
      document.documentElement.classList.add("theme-orange");
      // window.localStorage.setItem("theme", "theme-orange");
    } else {
      document.documentElement.classList.remove("theme-orange");
      // window.localStorage.removeItem("theme");
    }
  }, [theme]);

  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const handleThemeSwitch = () => {
    setTheme(theme === "theme-orange" ? "light" : "theme-orange");
    if (window.localStorage.getItem("theme") != null) {
      window.localStorage.removeItem("theme");
    } else {
      window.localStorage.setItem("theme", "theme-orange");
    }
  };

  useEffect(() => {
    if (window.localStorage.getItem("theme") != null) {
      // @ts-ignore
      setTheme(window.localStorage.getItem("theme"));
    }
  }, []);

  const customNavTrackHandler = (link: string) => {
    Tracker.trackClick({ custom_link_nav: link });
  };

  return (
    <>
      <nav
        className={`flex flex-col px-6 md:container md:mx-auto md:h-auto md:flex-row md:px-0 ${navHeightToggleClass} ${navToggleClass} items-start justify-start py-4  md:relative md:items-center md:justify-between md:bg-transparent ${bgMobileMenuClass}`}
      >
        <div className="flex justify-between w-full z- md:w-auto md:justify-start">
          <button
            className="block w-6 h-6 mr-3 cursor-pointer md:hidden"
            onClick={toggleViewMenu}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className={`${toggleLogoClass}`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          <Link to="/" className="">
            <img src={poloThemesLogo} alt="polo-themes" className="h-10" />
          </Link>

          <button
            className="w-6 h-6 md:hidden "
            // className="block w-6 h-6 mr-3 cursor-pointer md:hidden"
            // onClick={toggleViewMenu}
          >
            {/* MIGHT NEED THIS LATER FOR CLOSE BUTTON */}
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className={`${toggleLogoClass} ${logoCrossViewClass}`}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg> */}
          </button>
        </div>
        <div
          className={`${showMenuClass} blue-primary z-40 mt-8  flex h-full w-full flex-col justify-between text-white md:static md:mt-0 md:flex md:h-auto md:w-auto md:flex-grow md:flex-row md:justify-end md:bg-transparent md:text-slate-800
        `}
        >
          {isLoading ? (
            <>
              <div className="mb-2">
                <div className="h-5 w-72">
                  <Skeleton className="h-full" baseColor="#e6f1fc" />
                </div>
              </div>
              <div className="mb-2">
                <div className="w-20 h-5 ml-10">
                  <Skeleton className="h-full" baseColor="#e6f1fc" />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col items-start gap-5 pb-5 border-b border-white md:flex-row md:items-center md:border-none md:pb-0">
                <Link
                  to="/blog"
                  onClick={closeNavBar}
                  className="font-medium cursor-pointer hover:text-primary-500 md:mr-1 md:inline md:px-0 md:py-0"
                >
                  Blog
                </Link>
                <Link
                  to="/#faq"
                  onClick={closeNavBar}
                  className="block font-medium cursor-pointer hover:text-primary-500 md:mr-1 md:inline md:px-0 md:py-0"
                >
                  FAQ
                </Link>
                <Link
                  to={ROUTES.AFFILIATES}
                  className="block font-medium cursor-pointer hover:text-primary-500 md:mr-1 md:inline md:px-0 md:py-0"
                  onClick={() => customNavTrackHandler(ROUTES.AFFILIATES)}
                  activeClassName="text-primary-500"
                >
                  Become an Affiliate
                </Link>
                {/* <Link
                  to="/roadmap/figma-bundle/"
                  className="block cursor-pointer hover:text-primary-500 md:mr-1 md:inline md:px-0 md:py-0"
                >
                  Roadmap
                </Link> */}
                {/* ======== USE THIS FOR DROPDOWN LATER ======= */}
                {/* <Dropdown
              name={
                <p
                  className="flex items-center justify-between w-full hover:text-blue-500 md:w-auto"
                  onClick={handleDropdownIconToggle}
                >
                  <span>Support</span>
                  </p>
                }
                subItems={servicesDropdownArray}
                useHover={true}
                className="relative w-full cursor-pointer "
                menuClassName="hover:text-blue-500 items-center gap-2 w-full md:w-auto"
                itemsClassName="static bg-transparent shadow-none rounded-none ring-none text-white md:absolute md:right-0 md:mt-2 md:origin-top-right md:rounded-md md:bg-white md:shadow-lg md:ring-1 md:ring-black md:ring-opacity-5 md:text-slate-500 md:nav-dropdown-menu md:border-t-2 md:border-blue-600"
              /> */}
              </div>
              <div className="flex items-center gap-3 mt-3 md:mt-0">
                <div className="hidden h-6 ml-2 border-l border-gray-200 md:block"></div>
                {!isLoggedIN && (
                  <>
                    <button
                      className="block w-full py-2 mt-2 text-center border rounded-sm border-1 md:btn-primary-outline border-slate-400 md:mt-0 md:px-4"
                      onClick={signInHandler}
                    >
                      Sign in
                    </button>
                    {/* <button className="btn-primary">Sign up</button> */}
                  </>
                )}
                {isLoggedIN && (
                  <>
                    <Dropdown
                      name={
                        <div className="flex items-start w-full pb-1 mr-auto md:w-auto md:items-center md:pb-0">
                          <div className="w-6 h-6 overflow-hidden rounded-full">
                            <img
                              src={userImage}
                              alt="profile"
                              className="w-auto h-6"
                            />
                          </div>
                          <p className="px-2">{user.url.split("/").pop()}</p>
                        </div>
                      }
                      subItems={profileDropdownArray}
                      useHover={true}
                      start="open-sm"
                      className="w-full md:w-auto"
                      menuClassName="hover:text-primary-500 items-center gap-1 w-full md:w-auto"
                      itemsClassName="static bg-transparent w-full md:w-60 shadow-none rounded-none ring-none text-white md:absolute md:right-0 md:mt-2 md:origin-top-right md:rounded-md md:bg-white md:shadow-lg md:ring-1 md:ring-black md:ring-opacity-5 md:text-slate-500 md:nav-dropdown-menu md:border-t-2 md:border-primary-600"
                      size="l"
                    >
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`border-1 mt-2 block w-full rounded-sm border border-slate-400 py-2 text-center md:mt-0 md:border-t md:border-slate-200 md:px-4 md:text-left  ${
                              active && "text-primary-600"
                            }`}
                            onClick={signOutHandler}
                          >
                            Sign out
                          </button>
                        )}
                      </Menu.Item>
                    </Dropdown>
                  </>
                )}
              </div>
              {/* <button className="ml-4 btn-primary" onClick={handleThemeSwitch}>
                toggle
              </button> */}
            </>
          )}
        </div>
      </nav>
    </>
  );
};

export default Header;
